import { CSSProperties, PropsWithChildren } from 'react';

export function Text(
  props: PropsWithChildren<{
    // style variation
    header?: boolean;
    center?: boolean;
    // layout
    inline?: boolean;
    spaced?: boolean;
    // sizes
    xxl?: boolean;
    xl?: boolean;
    l?: boolean;
    m?: boolean;
    s?: boolean;
    xs?: boolean;
    // weights
    regular?: boolean;
    semiBold?: boolean;
    bold?: boolean;
    // colors
    avocado?: boolean;
    cashew?: boolean;
    cornflower?: boolean;
    cream?: boolean;
    marigold?: boolean;
    pumpkin?: boolean;
    tomato?: boolean;
    white?: boolean;
    cool20?: boolean;
    cool40?: boolean;
    cool60?: boolean;
    cool80?: boolean;
    cool100?: boolean;
    warm5?: boolean;
    warm10?: boolean;
    warm30?: boolean;
    warm50?: boolean;
    warm75?: boolean;
    warm90?: boolean;
    // fine grained control
    style?: CSSProperties;
  }>,
) {
  return (
    <div
      style={{
        textAlign: props.center ? 'center' : undefined,
        marginBottom: props.spaced ? 16 : 0,
        fontFamily: 'Inter, sans-serif',
        display: props.inline ? 'inline' : 'block',
        fontSize: props.header
          ? props.xxl
            ? 48
            : props.xl
              ? 40
              : props.l
                ? 32
                : props.m
                  ? 24
                  : props.s
                    ? 20
                    : props.xs
                      ? 16
                      : undefined
          : props.xxl
            ? 24
            : props.xl
              ? 20
              : props.l
                ? 16
                : props.m
                  ? 14
                  : props.s
                    ? 12
                    : props.xs
                      ? 10
                      : undefined,
        lineHeight: props.header
          ? props.xxl
            ? '58px'
            : props.xl
              ? '50px'
              : props.l
                ? '42px'
                : props.m
                  ? '34px'
                  : props.s
                    ? '30px'
                    : props.xs
                      ? '26px'
                      : undefined
          : props.xxl
            ? '32px'
            : props.xl
              ? '28px'
              : props.l
                ? '24px'
                : props.m
                  ? '20px'
                  : props.s
                    ? '16px'
                    : props.xs
                      ? '14px'
                      : undefined,
        fontWeight: props.semiBold ? 600 : props.bold ? 700 : props.regular ? 400 : undefined,
        letterSpacing: props.header && props.xxl ? '-1px' : 0,
        color: props.avocado
          ? 'var(--colors-avocado)'
          : props.cashew
            ? 'var(--colors-cashew)'
            : props.cornflower
              ? 'var(--colors-cornflower)'
              : props.cream
                ? 'var(--colors-cream)'
                : props.marigold
                  ? 'var(--colors-marigold)'
                  : props.pumpkin
                    ? 'var(--colors-pumpkin)'
                    : props.tomato
                      ? 'var(--colors-tomato)'
                      : props.white
                        ? 'var(--colors-white)'
                        : props.cool20
                          ? 'var(--colors-cool-20)'
                          : props.cool40
                            ? 'var(--colors-cool-40)'
                            : props.cool60
                              ? 'var(--colors-cool-60)'
                              : props.cool80
                                ? 'var(--colors-cool-80)'
                                : props.cool100
                                  ? 'var(--colors-cool-100)'
                                  : props.warm5
                                    ? 'var(--colors-warm-5)'
                                    : props.warm10
                                      ? 'var(--colors-warm-10)'
                                      : props.warm30
                                        ? 'var(--colors-warm-30)'
                                        : props.warm50
                                          ? 'var(--colors-warm-50)'
                                          : props.warm75
                                            ? 'var(--colors-warm-75)'
                                            : props.warm90
                                              ? 'var(--colors-warm-90)'
                                              : undefined,
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
}
